export const team = {
  addMember: {
    team: 'Ekipi',
    seeHowToUse: 'Shih si të përdoret',
    help: 'Ndihmë',
    addAMember: 'Shto një Anëtar',
    addYourTeamMembersText: 'Shtoni anëtarët e ekipeve tuaj si agjentë mbështetës për të biseduar në kohë reale me përdoruesit e botit.',
    name: 'Emri',
    nameIsRequired: 'Emri është i detyrueshëm',
    email: 'Email',
    enterAValidEmail: 'Vendosni një email të vlefshëm',
    password: 'Fjalëkalimi',
    passwordMustContain: 'Fjalëkalimi duhet të përmbajë',
    atleast6Characters: 'të paktën 6 karaktere,',
    oneUpperCaseLetter: '1 shkronjë të madhe',
    oneSpecialCharacter: '1 karakter i veçantë*',
    profileIcon: 'Ikonë Profili',
    whatsappNumber: 'Numri i WhatsApp',
    leadVisibility: 'Dukshmëria e Leada*',
    addMember: 'Shto Anëtar',
    role: 'Roli',
    createdOn: 'Krijuar më',
    action: 'Veprim',
    updateMember: 'Përditëso Anëtarin',
    add: 'Shto',
    cancel: 'Anulo',
    selectVisibilityOption: 'Zgjidhni opcionin e dukshmërisë',
    all: 'Të gjitha',
    assigned: 'Caktuar',
    nA: 'N/A',
    admin: 'Admin',
    agent: 'Agjent',
    placeholders: {
        enterMemberName: 'Vendos emrin e anëtarit',
        enterMemberEmailAddress: 'Vendos adresën e emailit të anëtarit',
        createPasswordForMember: 'Krijo një fjalëkalim për Anëtarin',
        searchCountry: 'Kërko Shtetin',
        enterWhatsappNumber: 'Vendosni Numrin e WhatsApp',
        selectLeadsVisibility: 'Zgjidhni dukshmërinë e leada',
        searchTeamByNameOrEmail: 'Kërko anëtarin e ekipeve sipas emrit ose emailit',
    },
    modal: {
        deleteTeamMember: 'Fshi anëtarin e ekipit',
        wantToDeleteThisTeamMember: 'A jeni të sigurt se dëshironi të fshini këtë anëtar të ekipit?',
    },
    appTooltip: {
        clickToAddNewTeamMember: 'Kliko për të shtuar një anëtar të ri të ekipit',
        profileIconOfTeamMember: 'Ikonë profili/imazhi i anëtarit të ekipit',
        nameOfTeamMember: 'Emri i anëtarit të ekipit',
        emailOfTeamMember: 'Email i anëtarit të ekipit',
        whatsappNumberOfTeamMember: 'Numri i WhatsApp i anëtarit të ekipit',
        roleOfTeamMemberAsAdminOrAgent: 'Roli i anëtarit të ekipit si admin/agjent',
        dateAndTimeOfCreatingTeamMemberRole: 'Data dhe koha e krijimit të rolit të anëtarit të ekipit',
        editOrDeleteTeamMember: 'Ndrysho/fshi anëtarin e ekipit',
        editTeamMembersDetails: `Ndrysho detajet e anëtarit të ekipit.`,
        removeAccessOfTeamMemberByDeletingAccount: 'Hiq aksesin e anëtarit të ekipit duke fshirë llogarinë',
    }
},
users: {
    manageMembers: 'Menaxho Anëtarët',
    managerMembersWhichCanAccessPanel: 'Menaxhoni ekipin tuaj të partnerëve që kanë qasje në panelin tuaj',
    createNewMember: 'Krijo Anëtar të Ri',
    createMember: 'Krijo Anëtar',
    updateMember: 'Përditëso Anëtarin',
    deleteTitleMember: 'Fshi Anëtar',
    deleteDescriptionMember: 'A jeni të sigurt se dëshironi të fshini këtë anëtar?',
    noMemberFound: 'Nuk u gjet asnjë anëtar!',
    titleMember: 'Krijo një Anëtar',
    manageUsers: 'Menaxho Përdoruesit',
    createNewUser: 'Krijo Përdorues të Ri',
    managerUserWhichCanAccessPanel: 'Menaxhoni përdoruesin tuaj që mund të ketë qasje në panelin tuaj',
    phoneNumber: 'Numri i Telefonit',
    discard: 'Hiqe',
    createUser: 'Krijo përdorues',
    updateUser: 'Përditëso Përdoruesin',
    noUserFOund: 'Nuk u gjet asnjë përdorues!',
    title: 'Krijo një Përdorues',
    profileIcon: 'Ikonë Profili*',
    name: 'Emri*',
    email: 'Email*',
    password: 'Fjalëkalimi*',
    selectRole: 'Zgjidh Roli*',
    selectARole: 'Zgjidh Rolin',
    selectLeadVisibility: 'Zgjidh dukshmërinë e leada*',
    confirmPassword: 'Konfirmo Fjalëkalimin*',
    tableHeadingName: 'Emri',
    tableHeadingEmail: 'Email',
    tableHeadingPhoneNumber: 'Numri i Telefonit',
    tableHeadingRole: 'Roli',
    tableHeadingStatus: 'Statusi',
    tableHeadingAction: 'Veprimi',
    deleteTitle: 'Fshi Përdoruesit',
    deleteDescription: 'A jeni të sigurt se dëshironi të fshini këtë përdorues?',
    placeholders: {
        searchHere: 'Kërko këtu',
        enterName: 'Vendos Emrin',
        enterEmail: 'Vendos email',
        searchCountry: 'Kërko shtetin',
        enterPhoneNumber: 'Vendos Numrin e Telefonit',
        enterPassword: 'Vendos fjalëkalimin',
        enterConfirmPassword: 'Vendos konfirmimin e fjalëkalimit'
    },
    appTooltip: {
        TOOLTIP_DELETE_USERS: 'Fshi përdoruesit',
        TOOLTIP_DELETE_MEMBERS: 'Fshi anëtarët'
    }
},
roles: {
    manageRoles: 'Menaxho Rolat',
    manageYourRoles: 'Menaxho rolet e tua.',
    name: 'Emri*',
    description: 'Përshkrimi',
    discard: 'Hiqe',
    createRole: 'Krijo Rol',
    creteARole: 'Krijo një Rol',
    updateRole: 'Përditëso Rolin',
    noUserFound: 'Nuk u gjet asnjë rol i përdoruesit!',
    assignPermissions: 'Cakto Lejet*',
    tableHeadingName: 'Emri',
    tableHeadingDescription: 'Përshkrimi',
    tableHeadingStatus: 'Statusi',
    tableHeadingAction: 'Veprimi',
    module: 'Moduli',
    read: 'Lexo',
    write: 'Shkruaj',
    remove: 'Fshi',
    notes: 'Shënime',
    deleteTitle: 'Fshi Roli',
    deleteDescription: 'Kujdes: Kur fshini këtë rol, gjithashtu do të fshihen të gjithë përdoruesit e caktuar me këtë rol. \n A jeni të sigurt se dëshironi të fshini këtë rol?',
    deleteMemberDescription: 'Kujdes: Kur fshini këtë rol, gjithashtu do të fshihen të gjithë anëtarët e caktuar me këtë rol. \n A jeni të sigurt se dëshironi të fshini këtë rol?',
    placeholders: {
        enterRoleName: 'Vendos emrin e rolit',
        searchHere: 'Kërko këtu',
        enterDescriptionForRole: 'Vendos një përshkrim për rolin'
    },
    appTooltip: {
        TOOLTIP_SECTION_TO_ALLOW_BLOCK: `Seksione që mund t'i lejoni ose bllokoni përdoruesit të kenë qasje`,
        TOOLTIP_CLICK_TO_ADD_ROLE: 'Kliko për të shtuar një Rol të ri',
    }
},
accessControl: {
    users: 'Përdoruesit',
    partnerTeam: 'Ekipi i Partnerit',
    members: 'Anëtarët',
    roles: 'Rrolet'
}
};
